import { TFunction } from 'i18next'

type FormatFunction = (
  messageDescriptor: ReactIntl.FormattedMessage.MessageDescriptor,
  values?: { [key: string]: ReactIntl.MessageValue }
) => string

// eslint-disable-next-line import/prefer-default-export
export const convertToTFunction = (
  formatMessage: FormatFunction
): TFunction => (id: string) => formatMessage({ id })

export const messagesFromKeysStartingWith = (
  prefix: string,
  messages: { [p: string]: string }
) =>
  Object.keys(messages)
    .filter((key) => key.startsWith(prefix))
    .map((key) => messages[key])

export const keysStartingWith = (
  prefix: string,
  messages: { [p: string]: string }
) =>
  Object.keys(messages)
    .filter((key) => key.startsWith(prefix))
    .reduce<string[]>((acc, key) => {
      const rootKey = prefix + key.replace(prefix, '').split('.')[0]
      return acc.includes(rootKey) ? acc : [...acc, rootKey]
    }, [])
